// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  message: '',
};

const actions = {
  getDrivers:
    (token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch('/api/bread/jwt/user_x_companies/static/list', options);
          const res = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ listDrivers: res.listDriver });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  getDriverId:
    (token, id) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch(
            `/api/bread/jwt/user_x_companies/static/edit?id=${id}`,
            options
          );
          const res = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ driver: res.driver });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  update:
    (data, token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch('/api/bread/jwt/user_x_companies/static/update', options);
          const garageWorkShopResponse = await response.json();

          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ status: garageWorkShopResponse.status });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  add:
    (data, token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch('/api/bread/jwt/user_x_companies/static/add', options);
          const garageWorkShopResponse = await response.json();

          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ status: garageWorkShopResponse.status });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
};

const Store = createStore({
  initialState,
  actions,
  name: 'driverRegister',
});

export default createHook(Store);
